/* script */
























































import Vue from 'vue';
import Component from 'vue-class-component';
import Page from './Page';

type UploadingStatus =
    | 'loading'
    | 'succeed'
    | 'uncaught_error'
    | 'upload_face_image_no_face'
    | 'upload_face_image_too_faces'
    | 'upload_passport_image_no_face'
    | 'upload_passport_image_too_faces';
@Component({ props: ['status'] })
class FaceModalComponent extends Vue {
    status!: UploadingStatus | null;

    _(label: string) {
        return (this.$parent as Page)._(label);
    }
}
const __vue_script__ = FaceModalComponent;

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { class: { hide: !_vm.status }, attrs: { id: "image_upload_status" } },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.status == "loading"
            ? [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm._("photo_upload_loading_title"))),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "caution",
                  attrs: { src: "/images/loading.gif" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "modal-status" }, [
                  _vm._v("Loading..."),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-description" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm._("photo_upload_loading_description"))),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.status == "succeed"
            ? [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm._("photo_upload_success_title"))),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "caution",
                  attrs: { src: "/images/icon_check-circle.svg" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "modal-status" }, [
                  _vm._v("Complete!"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-description" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm._("photo_upload_success_description"))),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.status == "uncaught_error"
            ? [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm._("photo_upload_failed_title"))),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "caution",
                  attrs: { src: "/images/icon_report-problem.svg" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "modal-description" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm._("photo_upload_apierror_description"))),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.status &&
          (_vm.status.includes("no_face") || _vm.status.includes("too_faces"))
            ? [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm._("photo_upload_failed_title"))),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "caution",
                  attrs: { src: "/images/icon_report-problem.svg" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "modal-description" }, [
                  _c("p", [_vm._v(_vm._s(_vm._(_vm.status)))]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "buttons" }, [
            _vm.status != "loading"
              ? _c(
                  "button",
                  {
                    staticClass: "skeleton",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._("close")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        2
      ),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "script_src/register/FaceCheckStatus.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__